import { z } from "zod";

/** Every QM response carries a literal source tag so the UI can label it. */
const qmSource = z.literal("qm");

export const FrictionPageSchema = z.object({
  path: z.string(),
  pageviews: z.number(),
  sessionsAffected: z.number(),
  rageClicks: z.number(),
  errorClicks: z.number(),
  frustration: z.number(),
  rageScrolls: z.number(),
  disabledInputClicks: z.number(),
  totalFriction: z.number(),
  frictionPer1kViews: z.number(),
  struggleScore: z.number(),
  lowVolume: z.boolean(),
  sampleSessionIds: z.array(z.string()),
  replayLinks: z.array(z.string()),
});
export type FrictionPage = z.infer<typeof FrictionPageSchema>;

export const QmFrictionSchema = z.object({
  source: qmSource,
  range: z.object({ from: z.string(), to: z.string() }),
  pages: z.array(FrictionPageSchema),
  excludedLowVolume: z.number(),
});
export type QmFriction = z.infer<typeof QmFrictionSchema>;

/** Which funnel definition the backend computed. */
export const QmFunnelTypeSchema = z.enum(["reservation", "quote"]);
export type QmFunnelType = z.infer<typeof QmFunnelTypeSchema>;

export const QmFunnelStageSchema = z.object({
  key: z.string(),
  label: z.string(),
  // SEQUENTIAL count — monotonic, bounded by `entered`. Source of truth.
  reached: z.number(),
  // Any-order hit count — diagnostic only, can exceed `reached`.
  visited: z.number(),
  conversionFromPrevPct: z.number(),
  dropOff: z.number(),
  dropOffSessionIds: z.array(z.string()),
  replayLinks: z.array(z.string()),
});
export type QmFunnelStage = z.infer<typeof QmFunnelStageSchema>;

export const QmFunnelSchema = z.object({
  source: qmSource,
  funnel: QmFunnelTypeSchema,
  label: z.string(),
  range: z.object({ from: z.string(), to: z.string() }),
  entered: z.number(),
  completed: z.number(),
  overallConversionPct: z.number(),
  stages: z.array(QmFunnelStageSchema),
});
export type QmFunnel = z.infer<typeof QmFunnelSchema>;
